// THE @Injectable DECLARE THIS AS A SERVICE SO THAT WE CAN INJECT THIS SERVICE IN ANY OTHER COMPONENT OR SERVICE
import { Directive, Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { GenericService } from "./generic.service";
import { ToastrService } from "ngx-toastr";
import { NotificationService } from "./notification/notification.service";
import { ThemeService } from "@progress/kendo-angular-charts";

@Directive()
@Injectable
	({
		providedIn: 'root'
	})

// DECLARING THE HelperService CLASS WITH EXPORT SO THAT WE CAN IMPORT THIS SERVICE INTO ANY OTHER COMPONENT OR SERVICE
export class HelperService {
	// THE OPEN FILE'S CURRENT STATUS, AS A PLAIN STRING ('Deal Fell Through', 'Closed', ...).
	// WRITTEN BY WHOEVER LAST READ get-loanapplication-status: the navbar (which owns the status
	// dropdown and re-reads after every change) and the loan application page. Read by the admin
	// API-reset buttons, which only exist on a file that has been marked Deal Fell Through.
	// Shared state rather than an @Input chain because the dropdown that changes it lives in the
	// navbar, three component trees away from the right side bar that has to react to it.
	public activeLoanApplicationStatus: string = '';
	public activeLoanApplicationId: string = '';
	public userInfo: any = {};
	public isFormModified: boolean = false;
	public noteStatus: any = false;
	public disableAddPropertyBtn: boolean = false;
	public leftSideMenuOpen: boolean = false;
	public isMobile: boolean = false;
	public applicationClosingdate: any;

	// OBSERVABLE TO BE TRIGGERED ON UPDATE BANKER.
	public onBankerUpdate: Subject<any> = new Subject<any>();

	// FIRED AFTER AN ADMIN API RESET, CARRYING THE SECTIONS THAT WERE CLEARED
	// (['flood'], or all three). THE RIGHT SIDE BAR SUBSCRIBES AND REBUILDS THOSE PANELS.
	// A SUBJECT RATHER THAN AN @Output CHAIN BECAUSE THE "Reset All API's" BUTTON LIVES IN THE
	// NAVBAR, NEXT TO THE STATUS DROPDOWN, WHICH IS A DIFFERENT COMPONENT TREE ENTIRELY FROM
	// THE PANELS IT HAS TO REFRESH.
	public onFileApisReset: Subject<string[]> = new Subject<string[]>();

	// FIRED WHEN THE SERVER HAS CHANGED THE PROPERTY ADDRESS OUT FROM UNDER THE OPEN SCREEN —
	// TODAY THAT MEANS A MOVE TO 'Deal Fell Through', WHICH BLANKS IT TO TBD. THE LOAN
	// APPLICATION PAGE RE-CREATES ITS STEP 3 FORM SO THE FIELDS STOP SHOWING THE OLD ADDRESS
	// (AND CANNOT WRITE IT BACK ON THE NEXT SAVE). SEPARATE FROM onFileApisReset BECAUSE NO API
	// SECTION CHANGED — THE SIDE BAR PANELS HAVE NOTHING TO REDRAW.
	public onPropertyAddressReset: Subject<void> = new Subject<void>();

	// FIRED WHEN A LOAN FILE IS SHARED WITH A CUSTOMER. THE NOTES PANEL SUBSCRIBES SO ITS
	// "VISIBLE TO THE CUSTOMER" OPTION APPEARS AS SOON AS THE FIRST SHARE EXISTS, WITHOUT A
	// RELOAD. A SUBJECT FOR THE SAME REASON AS onFileApisReset: THE SHARE DIALOG LIVES IN THE
	// NAVBAR AND THE NOTES PANEL LIVES IN THE RIGHT SIDE BAR — DIFFERENT COMPONENT TREES.
	public onLoanFileShareChanged: Subject<void> = new Subject<void>();

	// OBSERVABLE TO BE TRIGGERED ON LEFT MENU CHANGE IF LOAN APPLICATION FORM NOT SAVED.
	public onSideMenuChange: Subject<any> = new Subject<any>();

	public loan_application_id: string = '';

	// CONSTRUCTOR FUNCTION OF THE CLASS. IT WILL BE THE FIRST FUNCTION THAT WILL BE EXECUTED WHEN THIS CLASS LOADS.
	constructor(
		public genericService: GenericService,
		public toastrService: ToastrService,
		private notification: NotificationService
	) {
		if (localStorage.getItem('userInfo')) {
			let userInfo: any = localStorage.getItem('userInfo');
			this.userInfo = JSON.parse(userInfo);
		}
	}

	// CALL THIS FUNTION FOR ENABLE OR DISABLE NEXT BUTTON
	public checkDiableButtonForAddProperty(payload: any = null) {
		console.log('checkDiableButtonForAddProperty', payload);

		if (payload) {
			if (payload.currentStep == 3) {
				if (payload.approximateInterestRate > 0 && payload.monthlyTax > 0 && payload.monthlyHoi > 0 && payload.approximateInterestRate && payload.monthlyTax && payload.monthlyHoi) {
					this.disableAddPropertyBtn = false;
				} else {
					this.disableAddPropertyBtn = true;
				}

			} else {
				this.disableAddPropertyBtn = false;
			}

		} else {
			this.disableAddPropertyBtn = false;
		}
	}

	// FORMAT A NUMBER TO NUMBER FORMAT WITH DECIMAL
	formatPrice(value: any, decimal: number = 0) {
		if (value) {
			return '$' + parseFloat(parseFloat(value).toFixed(decimal)).toLocaleString("en-US",
				{
					useGrouping: true,
					minimumFractionDigits: decimal,
					maximumFractionDigits: decimal
				});
		} else {
			return '';
		}
	}

	// CHECk APPLICATION VALIDATION FOR RIGHT SIDE PANEL
	public async checkApplicationStep1validationForrightSidePanel(loanApplicationId: any = null): Promise<boolean> {
		console.log('loanApplicationId', loanApplicationId);

		if (!loanApplicationId) return false;

		try {
			// GET SEPT 1 DATA BY LOAN APPLICATION ID
			const step1response: any = await this.genericService.get(`step-1?loanapplication_id=${loanApplicationId}`).toPromise();
			let step1AddressInfo = step1response.data[0];


			// CHECK STEP 1 DATA VALIDATION
			if (!step1AddressInfo.address || step1AddressInfo.address.toLowerCase() == 'tbd' || !step1AddressInfo.city || step1AddressInfo.city.toLowerCase() == 'tbd' || !step1AddressInfo.state || step1AddressInfo.state.toLowerCase() == 'tbd' || !step1AddressInfo.zip_id || step1AddressInfo.zip_id.toLowerCase() == 'tbd') {
				this.notification.clear();
				this.notification.errorFromKey('MSG-RIGHTPANEL-BUTTON-TOAST-ERROR-MISSINGINFOSTEP1');
				return false;
			}

			// GET STEP 3 DATA BY LOAN APPLICATION ID
			const step3response: any = await this.genericService.get(`step-3-formatted?loanapplication_id=${loanApplicationId}`).toPromise();
			let step3AddressInfo = step3response.data['property_information'];

			// CHECK STEP 3 DATA VALIDATION
			if (!step3AddressInfo.propertyaddress || step3AddressInfo.propertyaddress.toLowerCase() == 'tbd' || !step3AddressInfo.propertystate || step3AddressInfo.propertystate.toLowerCase() == 'tbd' || !step3AddressInfo.propertycity || step3AddressInfo.propertycity.toLowerCase()	 == 'tbd' || !step3AddressInfo.propertyzipcode || step3AddressInfo.propertyzipcode.toLowerCase()	 == 'tbd') {
				this.notification.clear();
				this.notification.errorFromKey('MSG-RIGHTPANEL-BUTTON-TOAST-ERROR-MISSINGINFOSTEP3');
				return false;
			}

			return true;
		} catch (error) {
			this.notification.clear();
			this.notification.errorFromKey('MSG-RIGHTPANEL-BUTTON-TOAST-ERROR-SOMETHINGWENTWRONG');
			return false;
		}
	}
}
